<template>
  <section id="contents" class="page_account">
  	<div id="title_block">
  		<h1 class="title_text">パスワード再発行</h1>
  		<p class="btn_back"><a href="javascript:history.back();">戻る</a></p>
  	</div>
    <div class="contents_inner">
      <form @submit.prevent="forgotPassword">
        <div class="form_box">
          <table>
            <tr>
              <th>メールアドレス</th>
              <td>
                <p><input type="text" v-model="username" required></p>
                <p class="note">※ご登録メールアドレスが不明な場合は<router-link to="/login">こちら</router-link>よりご連絡ください</p>
              </td>
            </tr>
          </table>
        </div>
	  		<p class="submit"><input type="submit" value="送信"></p>
      </form>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data () {
    return {
      username: ''
    }
  },
  methods: {
    forgotPassword() {
      this.$cognito.forgotPassword(this.username)
        .then(result => {
          this.$router.replace('/confirm-password')
        })
        .catch(err => {
          this.$notify({ group: 'main', type: 'error', text: this.$i18n.t("message.forgot-password." + err.code) })
        })
    }
  }
}
</script>

<style scoped>
  @import '../assets/css/user.css'
</style>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue